<div class="reveal-container">
    <div class="media-container">
        <ng-container *ngIf="isTeasingDisplayed">
            <div class="reveal-teasing" [@teaserAnimation]>
                <div class="reveal-teasing-text" [innerHtml]="theme?.reveal?.teasing?.text"></div>
            </div>
        </ng-container>
        <ng-container *ngIf="!isTeasingDisplayed && theme?.reveal?.medias?.length">
            <ng-container *ngFor="let media of theme.reveal.medias; let i = index">
                <ng-container *ngIf="i === localIndexSelected">
                    <div class="media">
                        <!-- IMAGE -->
                        <div class="image-container" *ngIf="media?.type === 'Image'" [appBackgroundImage]="media.url"
                            (readyToDisplayImage)="initTimerImage();"></div>

                        <!-- Video Youtube/Vimeo -->
                        <div class="video-container">
                            <app-smash-player *ngIf="media?.type === 'Vimeo' || media?.type === 'Youtube' || media?.type === 'Video'"
                                [source]="playerSource"
                                [options]="playerOptions"
                                context="reveal"
                                (ended)="navigateMediaRight()">
                            </app-smash-player>
                        </div>

                        <!-- Iframe -->
                        <div class="iframe-container" *ngIf="media?.type === 'Iframe'">
                            <app-smash-iframe [scriptUrl]="media?.url" (ready)="initTimerImage();"></app-smash-iframe>
                        </div>

                        <!-- Tracking -->
                        <app-smash-theme-tracking [trackingMethods]="media?.trackingMethods"></app-smash-theme-tracking>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>

    <div class="reveal-preview-footer">
        <div class="title">
            <p [innerHtml]="theme?.reveal?.text"></p>
        </div>
        <div class="reveal-preview-footer-right-container">
            <ng-container *ngIf="theme?.reveal?.medias?.length > 1">
                <div class="navigation-arrows-container">
                    <div class="icon-navigation-left" (click)="navigateMediaLeft()">
                        <i class="icon-smash_arrow_navigation icon-navigation icon-navigation-left"></i>
                    </div>
                    <div class="pager">{{ localIndexSelected + 1 }} / {{ theme.reveal.medias.length }}</div>
                    <div class="icon-navigation-right" (click)="navigateMediaRight()">
                        <i class="icon-smash_arrow_navigation icon-navigation icon-navigation-right"></i>
                    </div>
                </div>
            </ng-container>
            <div class="cta-container">
                <div class="btn dark" *ngIf="theme?.reveal?.callToAction?.url" (click)="onCtaClick()">
                    {{ theme?.reveal?.callToAction?.label }}
                </div>
            </div>
        </div>
    </div>
</div>
